import _ from "lodash";
import {
  ListsService,
  ListsProvider,
  APP_CODE,
  HttpService,
} from "@sportal/api";

import { UrlFilters } from "./appConfigService.types";

export const makeListsService = (
  http: HttpService,
  backendUrl: string,
  urlFilters: UrlFilters
): ListsService =>
  new ListsService(
    new ListsProvider(http, backendUrl, APP_CODE.SB),
    _.get(urlFilters, "url-types"),
    APP_CODE.SB
  );
